<script setup>
import { ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';
import Banner from 'dashboard/components-next/banner/Banner.vue';

import tiktokClient from 'dashboard/api/channel/tiktokClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useAdmin } from 'dashboard/composables/useAdmin';

const { t } = useI18n();
const { isAdmin } = useAdmin();

const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await tiktokClient.generateAuthorization();

    const {
      data: { url },
    } = response;

    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.TIKTOK.ERROR_AUTH'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired
    v-if="isAdmin"
    class="mx-6"
    @reauthorize="requestAuthorization"
  />
  <Banner v-else color="ruby" class="mx-6">
    {{ $t('INBOX_MGMT.TIKTOK_REAUTHORIZE.AGENT_INFO') }}
  </Banner>
</template>
